import gql from 'graphql-tag';

const UPDATE_RESPONDENT_DETAILS = gql`
mutation ($input : UpdateRespondentDetailsInput!) {
    updateRespondentDetails(input: $input) {
        respondent {
            id
        }
    }
}
`;

export default UPDATE_RESPONDENT_DETAILS;
